import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Button } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    scroller: any;
}

/** 绑定全局数据到props */

@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthFooter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <div className='text-right'>
                <div className='mr10' style={{ display: 'inline-block',marginRight:50 }}>
                    <div className='bold_number'>
                        {Field.formatMoney(this.modulesState.draftedAmount, 2)}
                    </div>
                    <div>已勾选金额</div>
                </div>
                <div className='mr10' style={{ display: 'inline-block',marginRight:50 }}>
                    <div className='bold_number'>
                        {Field.formatMoney(this.modulesState.draftedTax, 2)}
                    </div>
                    <div>已勾选税额</div>
                </div>
                <div className='mr10' style={{ display: 'inline-block' }}>
                    <div className='bold_number'> {this.modulesState.draftedLength}</div>
                    <div>已勾选发票张数</div>

                </div>
                <span onClick={() => { this.props.scroller.toTop(); }}>
                    <Button icon="huidaodingbuanniu" shape="circle" size='small' style={{color:'#99A9BF'}}/>
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.Auth.Footer.tsx